import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  InputContainer,
  FormulaPrintModalContainer
} from '../template/FormulaFormTemplates';
import { BoxInletDropVM } from './BoxInletDropVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';
import { StageDischargeGraph } from '../Common/StageDischargeGraph';


const BoxInletDropComponent = (props) => {
  const vm = useRef(new BoxInletDropVM(props)).current;
  useEffect(() => {
    // on initial render, load form data - desc, img, help link
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />    
      <div className="row formula-content">
        <InputContainer computeCallback={() => {vm.computeParaCh() }} printCallback={() => vm.launchAndExport()} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={!vm.hasResults}>
        <h2 className='sections-heading'>General</h2>
          <Input
            label="Width (ft)"
            idAndName="width"
            valid={!vm.formValidation.width}
            value={vm.boxInletDropFrom.width}
            className={vm.BoxInletDropErrorClass('width')}
            type="number"
            step={'0.01'}
            onChange={(e) => { vm.handleBoxInletDropForm(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
          />
          <Input label="Length (ft)"
            idAndName="length"
            valid={!vm.formValidation.length}
            value={vm.boxInletDropFrom.length}
            className={vm.BoxInletDropErrorClass('length')}
            type="number"
            step={'0.01'}
            onChange={vm.handleBoxInletDropForm}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
          />
          <Input
            label="Head Above Weir (ft)"
            idAndName="Head_Above_Weir"
            valid={!vm.formValidation.headAboveWeir}
            value={vm.boxInletDropFrom.headAboveWeir}
            className={vm?.BoxInletDropErrorClass('headAboveWeir')}
            type="number"
            step={'0.01'}
            onChange={vm.handleBoxInletDropForm}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
          />
          <Input
            label="Weir Elevation (ft)"
            idAndName="Weir_Elevation"
            valid={!vm.formValidation.weirElevation}
            value={vm.boxInletDropFrom.weirElevation}
            className={vm?.BoxInletDropErrorClass('weirElevation')}
            type="number"
            step={'0.01'}
            onChange={(e) => { vm.handleBoxInletDropForm(e) }}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
          />
          <Input
            label="Floor Elevation (ft)"
            idAndName="Floor_Elevation"
            valid={!vm.formValidation.floorElevation}
            value={vm.boxInletDropFrom.floorElevation}
            className={vm?.BoxInletDropErrorClass('floorElevation')}
            type="number"
            step={'0.01'}
            onChange={vm.handleBoxInletDropForm}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
          />
        </InputContainer >
        <div className="col formula-information" >
          {vm.hasResults ? (
            <Fragment>
              <div className="row formula-results">
                <ResultsContainer>
                  <div className="col result-value-group">
                    <div className="row">
                      <div className="col-auto result-label">Capacity Q (cfs):</div>
                      <div className="col-4 result-value">{vm.boxInletDropResults.capacityQ}</div>
                    </div>
                    <div className="row">
                      <div className="col-auto result-label">Minimum Channel Width (ft):</div>
                      <div className="col-4 result-value">{vm.boxInletDropResults.minChannelWidth}</div>
                    </div>
                    <div className="row">
                      <div className="col-auto result-label">Top Elevation (ft):</div>
                      <div className="col-4 result-value">{vm.boxInletDropResults.topZ}</div>
                    </div>
                  </div>
                </ResultsContainer>
              </div>
              {vm.plotData ? <StageDischargeGraph targetDivId={vm.targetDivID} plotData={vm.plotData} windowOptions={vm.windowOptions} forReport={false}/> : null}
            </Fragment>
          ) : null}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              <img
                className=""
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
        // These 3 lines should be added for manually formatted formulas including a graph
        windowOptions={vm.windowOptionsForPrint}
        stageDischarge={vm.plotData !== undefined ? true : false}// Should be true for this formula. plotData should be propulated in correct format after api results
        stageDischargeData={vm.plotData}
      />
    </Fragment>
  );
};

export const BoxInletDropFormula = observer(BoxInletDropComponent);